import { PartnerOfferTile, TileStatus } from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { ProductOfferCardProps } from 'shared/components/vxl/cards/ProductOfferCard/ProductOfferCard';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';
import { capitalizeWord } from 'shared/utils/string/string.helpers';
import { Maybe } from 'shared/utils/types';

interface PromotionTilesNode extends VXLComponent {
  id: string;
  name: VXLComponentId.PRODUCT_OFFER_CARD;
  props: ProductOfferCardProps;
}

const partnerOfferTile = (
  tile: PartnerOfferTile,
  dependencies: HomeCardDependencies,
): Maybe<PromotionTilesNode> => {
  if (tile.status !== TileStatus.Loaded) {
    return null;
  }
  const { title, description, cta } = tile;
  const formattedCta = cta ? capitalizeWord(cta) : '';
  const { homeReferralTileClicked } = dependencies;
  return {
    id: tile.id,
    name: VXLComponentId.PRODUCT_OFFER_CARD,
    props: {
      titleText: title || '',
      bodyText: description || '',
      buttonText: formattedCta,
      // TODO: JT-120793 - Illustration URL Handling
      illustrationKey: 'HIGH_FIVE_A',
      illustrationBackgroundColor: theme.color.expressive.blush,
      onPress: () => {
        homeReferralTileClicked();
      },
      analyticsId: 'referralClicked',
    },
  };
};

export default partnerOfferTile;
